__turbopack_context__.v({
  "_fill": "CustomImageBanner-module-scss-module__edDC2q___fill",
  "banner": "CustomImageBanner-module-scss-module__edDC2q__banner",
  "desktop": "CustomImageBanner-module-scss-module__edDC2q__desktop",
  "disabled": "CustomImageBanner-module-scss-module__edDC2q__disabled",
  "imageContainer": "CustomImageBanner-module-scss-module__edDC2q__imageContainer",
  "mobile": "CustomImageBanner-module-scss-module__edDC2q__mobile",
  "tablet": "CustomImageBanner-module-scss-module__edDC2q__tablet",
});
